import React, { useRef, useState, useEffect, InputHTMLAttributes } from "react";

// packages
import classnames from "classnames";

// material ui componetns
import Box from "@mui/material/Box";
// import Input from "@mui/material/Input";

// styles
import styles from "./styles.module.css";

// types
// import { InputProps } from "@mui/material";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label?: string;
  data?: { id: number | string; name: string }[];
  shownValue?: { id: number | string; name: string };
  // eslint-disable-next-line no-unused-vars
  handleChange: (value: { id: number | string; name: string }) => void;
  variant?: "small" | "default";
}

const DropdownAlternate: React.FC<Props> = ({
  data,
  shownValue,
  handleChange,
  variant = "default",
  label,
  ...props
}: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const ref = useRef<HTMLDivElement | null>(null);

  // const [focused, setFocused] = useState(false);
  const [showAndHideDropDown, setShowAndHideDropDown] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!ref?.current?.contains(event?.target)) {
        setShowAndHideDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, [ref]);

  const handleDropDownIconClick = () => {
    setShowAndHideDropDown(!showAndHideDropDown);
  };

  const isSelected = (itemId: string | number) => {
    return shownValue?.id === itemId && shownValue?.id !== "";
  };

  const hasValue = shownValue?.id && shownValue?.id !== "";

  return (
    <div
      onClick={handleDropDownIconClick}
      ref={ref}
      className={classnames(styles.container, {
        [styles.small]: variant === "small",
        [styles.selected]: hasValue,
      })}>
      {hasValue && label && <span className={styles.label}>{label}</span>}
      <input
        ref={inputRef}
        onFocus={(e) => {
          props?.onFocus && props.onFocus(e);
        }}
        onBlur={(e) => {
          props?.onBlur && props?.onBlur(e);
          setShowAndHideDropDown(false);
        }}
        disabled={true}
        value={shownValue?.name || ""}
        placeholder={props.placeholder || label || ""}
        className={classnames({
          [styles.hasValue]: hasValue,
        })}
        {...props}
      />
      <Box
        component="img"
        src="/assets/images/svg/downArrow.svg"
        className={styles["dropdown_icon"]}
      />
      {data && (
        <div
          className={
            showAndHideDropDown ? styles["dropdown"] : styles["dropdown-hide"]
          }>
          <li
            className={styles.clearOption}
            onClick={(e) => {
              e.stopPropagation();
              handleChange({ id: "", name: "" });
              handleDropDownIconClick();
            }}>
            Clear
          </li>
          {data?.map((content, index) => (
            <li
              key={index}
              className={isSelected(content.id) ? styles.selectedItem : ""}
              onClick={() => {
                handleChange(content);
                handleDropDownIconClick();
              }}>
              {content?.name}
            </li>
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(DropdownAlternate);
